export default __webpack_public_path__ + "static/media/news3.a3df39b8.jpg";